import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, Space } from 'antd';

import type { FilterDropdownProps } from 'antd/es/table/interface';

import SearchOutlined from '@ant-design/icons/SearchOutlined';

import themeToken from '@lib/theme/tokens/index';

const TablesSearchDropdown = ({
  dataIndex,
  selectedKeys,
  clearFilters,
  confirm,
  setSelectedKeys,
  setSecondarySearchToken,
  close,
  setSearchToken,
}: {
  dataIndex: string;
  selectedKeys: React.Key[];
  clearFilters: (() => void) | undefined;
  confirm: FilterDropdownProps['confirm'];
  setSelectedKeys: (keys: React.Key[]) => void;
  close: () => void;
  setSearchToken?: (searchToken?: string) => void;
  setSecondarySearchToken?: (searchToken?: string) => void;
}) => {
  const searchInput = useRef(null);
  const { t } = useTranslation(['common', 'captable']);

  const handleSearch = (selectedSearchKeys: string[], onConfirm: FilterDropdownProps['confirm']) => {
    onConfirm();
    if (setSecondarySearchToken && dataIndex === 'grant_name') {
      setSecondarySearchToken(selectedSearchKeys[0]);
    } else if (setSearchToken) {
      setSearchToken(selectedSearchKeys[0]);
    }
  };

  return (
    <div style={{ padding: themeToken.padding }}>
      <Input
        ref={searchInput}
        placeholder={` ${t('searchBy')}${t(`vesting.vestingTable.${dataIndex}`, { ns: 'captable' })}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys as string[], confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          {t('search')}
        </Button>

        <Button
          onClick={() => {
            if (clearFilters) {
              clearFilters();
              if (setSearchToken) {
                setSearchToken(undefined);
                confirm();
              }
              if (setSecondarySearchToken) {
                setSecondarySearchToken(undefined);
                confirm();
              }
            }
          }}
          size="small"
          style={{ width: 90 }}
        >
          {t('reset')}
        </Button>

        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          {t('close')}
        </Button>
      </Space>
    </div>
  );
};

export default TablesSearchDropdown;
